import { IGatsbyImageData } from 'gatsby-plugin-image';

interface FallbackImageProps {
  mobile?: string | IGatsbyImageData;
  tablet?: string | IGatsbyImageData;
  desktop?: string | IGatsbyImageData;
}

/**
 * Returns the most appropriate image fallback for a given device type.
 */
export const getFallbackImage = (
  size: 'mobile' | 'tablet' | 'desktop',
  { mobile, tablet, desktop }: FallbackImageProps
): string | IGatsbyImageData => {
  const fallbackMap: {
    [key in 'mobile' | 'tablet' | 'desktop']: (
      | string
      | IGatsbyImageData
      | undefined
    )[];
  } = {
    mobile: [mobile, tablet, desktop],
    tablet: [tablet, mobile, desktop],
    desktop: [desktop, tablet, mobile],
  };

  return fallbackMap[size].find((image) => !!image) as
    | string
    | IGatsbyImageData;
};
